import { StyleSheet, StatusBar, Dimensions } from 'react-native';
import { colors } from './colors';
import coef from './coef';
const SCREEN_HEIGHT = Dimensions.get('window').height;
const SCREEN_WIDTH = Dimensions.get('window').width;

export const styles = StyleSheet.create({
	container: {
		// alignItems: 'center',
		// justifyContent: 'center',
		// paddingTop: Platform.OS === 'android' ? StatusBar.currentHeight : 0,
		// backgroundColor: colors.black2,
		// backgroundColor: '#12152a',
		// backgroundColor: '#252250',
		// paddingTop: Platform.OS === 'android' ? StatusBar.currentHeight : 0,
		// paddingTop: 80,
		// padding: 10,
		minHeight: SCREEN_HEIGHT,
		paddingLeft: 8,
		paddingRight: 8,
		// paddingBottom: 30,
	},
	navigationContainer: {
		display: 'flex',
		flexDirection: 'row',
		alignItems: 'center',
		marginTop: 30,
		justifyContent: 'space-between',
		paddingRight: 5,
	},
	navigationElements: {
		display: 'flex',
		flexDirection: 'row',
	},
	marginTopElement: {
		marginTop: 15,
	},
	mainHeading: {
		fontSize: 24,
		color: '#fff',
		fontFamily: 'Lato_700Bold',
		marginLeft: 10,
		// paddingTop: 20,
		letterSpacing: -1,
	},
	title: {
		fontSize: 20,
		fontWeight: 'bold',
	},
	separator: {
		marginVertical: 30,
		height: 1,
		width: '80%',
	},
	events: {
		display: 'flex',
		flexDirection: 'column',
		marginTop: 12,
		paddingBottom: 10,
		transition: 'all 1s',
	},
	event: {
		// backgroundColor: colors.greyBackground,
		height: 70 * coef,
		// padding: 10,
		marginTop: 5,
		marginBottom: 5,
		marginLeft: 10,
		marginRight: 10,
		display: 'flex',
		flexDirection: 'row',
		// justifyContent: 'space-between',
		paddingRight: 5,
		// borderWidth: 2,
		// borderColor: colors.yellow,
		justifyContent: 'space-between',
		overflow: 'hidden',
		borderRadius: 6,
	},
	event_sub: {
		// backgroundColor: colors.greyBackground,
		height: 70 * coef,
		// padding: 10,
		marginTop: 5,
		marginBottom: 5,
		marginLeft: 10,
		marginRight: 10,
		display: 'flex',
		flexDirection: 'row',
		// justifyContent: 'space-between',
		paddingRight: 5,
		// borderWidth: 2,
		// borderColor: colors.yellow,
		justifyContent: 'space-between',
		overflow: 'hidden',
		borderRadius: 6,
		marginLeft: 60 * coef,
	},
	image: {
		width: 70 * coef,
		height: 70 * coef,
		padding: 0,
	},
	image_2_1: {
		width: 70 * coef,
		height: 70 * coef,
		clipPath: 'polygon(0 0, 100% 0, 0 100%)',
		position: 'absolute',
	},
	image_2_2: {
		width: 70 * coef,
		height: 70 * coef,
		clipPath: 'polygon(100% 100%, 0 100%, 100% 0)',
		position: 'absolute',
	},
	image_2: {
		width: 31 * coef,
		height: 70 * coef,
		marginLeft: 2 * coef,
		marginRight: 2 * coef,
	},
	image_3: {
		width: 31 * coef,
		height: 31 * coef,
		margin: 2 * coef,
		borderRadius: 6 * coef,
	},

	image_support: {
		width: 28 * coef,
		height: 28 * coef,
		position: 'absolute',
		bottom: 2 * coef,
		right: 2 * coef,
		borderRadius: 50,
		boxShadow: '0 5px 10px rgba(0,0,0,0.3)',
		borderWidth: 1,
		borderStyle: 'solid',
		borderColor: 'white',
	},
	image_support_2: {
		width: 28 * coef,
		height: 28 * coef,
		position: 'absolute',
		bottom: 2 * coef,
		right: 14 * coef,
		borderRadius: 50,
		boxShadow: '0 5px 10px rgba(0,0,0,0.3)',
		borderWidth: 1,
		borderStyle: 'solid',
		borderColor: 'white',
	},

	image_main: {
		width: 70 * coef,
		height: 70 * coef,
		padding: 0,
	},

	image_container: {
		width: 70 * coef,
		height: 70 * coef,
		display: 'flex',
		flexDirection: 'row',
		flexWrap: 'wrap',
	},

	eventInformation: {
		display: 'flex',
		flexDirection: 'column',
		paddingLeft: 10 * coef,
		fontFamily: 'Lato_400Regular',
		fontSize: 28 * coef,
		justifyContent: 'flex-start',
		// backgroundColor: '#2A2D40',
		// width: 205,
	},
	eventGenres: {
		display: 'flex',
		flexDirection: 'row',
		paddingTop: 5 * coef,
	},
	eventDate: {
		display: 'flex',
		flexDirection: 'column',
		justifyContent: 'center',
		alignItems: 'flex-start',
		// backgroundColor: '#2A2D40',
		// minWidth: 65,
		// position: 'absolute',
		// right: 0,
		// top: 7,
	},
	eventTitle: {
		fontFamily: 'Lato_400Regular',
		fontSize: 13 * coef,
		color: colors.white,
		textTransform: 'uppercase',
		letterSpacing: 1 * coef,
		paddingTop: 6 * coef,
	},
	eventAddress: {
		fontFamily: 'Lato_400Regular',
		fontSize: 12 * coef,
		color: colors.lightGrey,
		textTransform: 'uppercase',
		letterSpacing: 1 * coef,
		paddingTop: 2 * coef,
	},
	eventGenre: {
		fontFamily: 'Lato_400Regular',
		fontSize: 10 * coef,
		backgroundColor: colors.yellow,
		padding: 3 * coef,
		borderRadius: 3,
		marginRight: 4 * coef,
		textTransform: 'uppercase',
		display: 'flex',
		alignItems: 'center',
		justifyContent: 'center',
	},
	event__yellow: {
		backgroundColor: colors.yellow,
	},
	event__purple: {
		backgroundColor: colors.purple,
	},
	event__green: {
		backgroundColor: colors.green,
	},
	eventContainer: {
		// backgroundColor: colors.black2,
		// paddingTop: Platform.OS === 'android' ? StatusBar.currentHeight : 0,
	},
	title: {
		fontSize: 20,
		fontWeight: 'bold',
	},
	separator: {
		marginVertical: 30,
		height: 1,
		width: '80%',
	},
	coverImage: {
		height: 200,
		width: '100%',
	},
	imageBackground: {
		height: 280,
		flexDirection: 'row',
	},
	imageTitle: {
		fontSize: 30,
		alignSelf: 'flex-end',
		color: colors.white,
		fontFamily: 'Lato_400Regular',
		textTransform: 'uppercase',
		letterSpacing: 2,
		paddingBottom: 20,
		paddingLeft: 45,
		textShadowColor: 'rgba(0,0,0,0.75)',
		textShadowRadius: 15,
		textShadowOffset: { width: -1, height: 1 },
	},
	imageTime: {
		fontSize: 22,
		position: 'absolute',
		right: 5,
		top: 10,
		display: 'flex',
		alignContent: 'center',
		justifyContent: 'center',
		textAlign: 'center',
	},
	imageDate: {
		fontFamily: 'Lato_400Regular',
		textTransform: 'uppercase',
		letterSpacing: 2,
		color: colors.black2,
		textAlign: 'center',
		textShadowColor: 'rgba(255,255,255,0.75)',
		textShadowRadius: 15,
		textShadowOffset: { width: -1, height: 1 },
	},
	imageHour: {
		color: colors.white,
		fontSize: 40,
		marginTop: -5,
		textShadowColor: 'rgba(0,0,0,0.75)',
		textShadowRadius: 15,
		textShadowOffset: { width: -1, height: 1 },
	},
	info: {
		flexDirection: 'column',
		// backgroundColor: '#121531',
		paddingTop: 15,
		paddingLeft: 25,
		paddingRight: 25,
		marginTop: 0,
	},
	eventDescription: {
		// flex: 1.4,
	},
	eventDetails: {
		display: 'flex',
		flexDirection: 'column',
		// flex: 0.6,
	},
	artistDescription: {
		color: '#e9ecef',
		fontFamily: 'Lato_400Regular',
	},
	spotifyNew: {
		height: '100px',
	},
	spotify: {
		height: '80px',
		minHeight: '80px',
		// backgroundColor: colors.greyBackground,
		marginBottom: 40,
		paddingLeft: -5,
		borderLeftWidth: 5,
		// borderColor: 'rgba(0,0,0,0)',
		borderLeftColor: colors.yellow,
		opacity: 0.99,
		overflow: 'hidden',
	},
	spotifyEmbedded: {
		height: 80,
		// marginBottom: 400,
	},
	overlay: {
		...StyleSheet.absoluteFillObject,
		backgroundColor: 'rgba(255,255,255,0.3)',
	},
	absoluteFillObject: {
		position: 'relative',
		top: 0,
		left: 0,
		right: 0,
		bottom: 0,
	},
	detail__single: {
		paddingBottom: 20,
	},
	detail__icon: {
		textAlign: 'center',
		color: colors.white,
		paddingBottom: 8,
	},
	navigation__icon: {
		textAlign: 'center',
		color: colors.white,
		marginLeft: 17,
	},
	some__icon: {
		color: colors.white,
	},
	detail__description: {
		textAlign: 'center',
		color: colors.lightGrey,
		fontFamily: 'Lato_400Regular',
		textTransform: 'uppercase',
		letterSpacing: 1,
	},
	event__eventGenres: {
		display: 'flex',
		flexDirection: 'column',
		paddingTop: 5,
		alignContent: 'center',
		justifyContent: 'center',
		textAlign: 'center',
	},
	event__yellow: {
		backgroundColor: colors.yellow,
	},
	event__purple: {
		backgroundColor: colors.purple,
	},
	event__green: {
		backgroundColor: colors.green,
	},
	event__eventGenre: {
		fontFamily: 'Lato_400Regular',
		fontSize: 10,
		backgroundColor: colors.yellow,
		padding: 3,
		borderRadius: 3,
		marginRight: 4,
		textTransform: 'uppercase',
		textAlign: 'center',
		marginTop: 8,
	},

	event__details: {
		// backgroundColor: '#121531',
		// backgroundColor: '#3b5998',
		display: 'flex',
		flexDirection: 'row',
		justifyContent: 'space-between',
		marginBottom: 15 * coef,
		marginTop: 10 * coef,
		borderRadius: 30,
		paddingTop: 10 * coef,
		// overflow: 'hidden',
	},

	event__details__single: {
		display: 'flex',
		flexDirection: 'column',
		alignItems: 'center',
		// flex: 1,
	},

	event__details__single__bigText: {
		fontFamily: 'Lato_400Regular',
		fontSize: 12 * coef,
		color: colors.white,
		textTransform: 'uppercase',
		letterSpacing: 1 * coef,
	},
	event__details__single__smallText: {
		fontFamily: 'Lato_400Regular',
		fontSize: 9 * coef,
		color: colors.lightGrey,
		textTransform: 'uppercase',
		letterSpacing: 1 * coef,
		textAlign: 'center',
		// borderBottomWidth: 2,
		// borderBottomColor: 'white',
	},
	eventWhen: {
		fontFamily: 'Lato_400Regular',
		fontSize: 24 * coef,
		color: colors.white,
		textTransform: 'uppercase',
		letterSpacing: 1 * coef,
	},
	eventTime: {
		fontFamily: 'Lato_400Regular',
		fontSize: 11 * coef,
		color: colors.lightGrey,
		textTransform: 'uppercase',
		letterSpacing: 1.5 * coef,
	},
	artistName: {
		color: 'rgba(255, 255, 255, 1)',
		// position: 'absolute',
		// textAlign: 'center',
		// top: 0,
		fontSize: 22,
		// marginTop: -90,
		marginTop: -50,
		alignSelf: 'center',
		fontFamily: 'Lato_400Regular',
		textTransform: 'uppercase',
		letterSpacing: 1.2,
		textShadowColor: 'rgba(0,0,0,1)',
		textShadowRadius: 4,
		textShadowOffset: { width: 1, height: 4 },
		textAlign: 'center',
	},
	socialMediaContainer: {
		display: 'flex',
		flexDirection: 'row',
	},
	socialMediaContent: {
		display: 'flex',
		flexDirection: 'column',
		paddingRight: 20,
	},
	iconsContainer: {
		display: 'flex',
		flexDirection: 'row',
	},
	someText: {
		display: 'flex',
		flexDirection: 'row',
		alignItems: 'center',
		color: colors.white,
		textTransform: 'uppercase',
		fontSize: 14,
		marginRight: 5,
		// backgroundColor: colors.yellow,
		padding: 3,
		borderRadius: 8,
	},
	someText__title: {
		// textTransform: 'uppercase',
		color: colors.lightGrey,
		letterSpacing: 1.4,
		paddingBottom: 7,
	},
	event__heading: {
		fontSize: 14,
		fontFamily: 'Lato_400Regular',
		textTransform: 'uppercase',
		letterSpacing: 1,
		paddingTop: 35,
		paddingBottom: 8,
		color: colors.white,
	},

	event__heading__top: {
		paddingTop: 10,
		paddingBottom: 1,
	},

	event__heading__container: {
		display: 'flex',
		paddingBottom: 8,
	},
	underline: {
		backgroundColor: colors.yellow,
		height: 2,
		width: '50%',
	},
	underline__ticket: {
		backgroundColor: colors.yellow,
		height: 2,
		width: '65%',
		marginTop: -10,
	},
	ticketsButton: {
		display: 'flex',
		flexDirection: 'row',
		fontSize: 28,
		color: colors.white,
		// backgroundColor: colors.yellow,
		justifyContent: 'space-between',
		alignItems: 'center',
		padding: 10,
		borderRadius: 10,
		width: '80%',
		marginTop: 20,
	},

	ticketsButton__text: {
		color: colors.white,
		textTransform: 'uppercase',
		fontFamily: 'Lato_400Regular',
		letterSpacing: 1.1,
	},

	ticketsButton__icon: {
		color: colors.white,
	},
	ticketsButton__iconContainer: {
		padding: 3,
		backgroundColor: 'rgba(0,0,0,0.1)',
		borderRadius: 4,
	},
	event__genreContainer: {
		display: 'flex',
		flexDirection: 'row',
		// justifyContent: 'center',
		marginTop: 0,
		marginBottom: 6,
	},
	event__singleGenre: {
		// paddingLeft: 8,
		// paddingRight: 8,
		// paddingTop: 6,
		// paddingBottom: 6,
		display: 'flex',
		padding: 8,
		color: colors.white,
		fontFamily: 'Lato_400Regular',
		textTransform: 'uppercase',
		fontSize: 9,
		borderWidth: 2,
		borderRadius: 12,
		margin: 2,
		// display: 'flex',
		flexDirection: 'row',
		// justifyContent: 'center',
		// alignItems: 'center',
		textAlign: 'center',
	},
	event__singleGenre__container: {
		// display: 'flex',
		// justifyContent: 'center',
		// alignItems: 'center',
		display: 'flex',
		justifyContent: 'center',
		borderWidth: 2,
		borderRadius: 12,
		margin: 2,
		padding: 8,
	},
	event__singleGenre__text: {
		color: colors.white,
		fontFamily: 'Lato_400Regular',
		textTransform: 'uppercase',
		fontSize: 9,
		padding: 0,
		margin: 0,
		includeFontPadding: false,
	},

	event__singleGenre__yellow: {
		borderColor: colors.yellow,
		color: colors.yellow,
	},
	event__singleGenre__green: {
		borderColor: colors.green,
		color: colors.green,
	},
	event__singleGenre__purple: {
		borderColor: colors.purple,
		color: colors.purple,
	},
	gradientBackground: {
		height: 400,
	},
	loading__text: {
		color: colors.lightGrey,
		textAlign: 'center',
		fontSize: 18,
		fontFamily: 'Lato_400Regular',
		marginTop: '40%',
		letterSpacing: 1,
		marginBottom: 20,
	},
	search_icon: {
		color: colors.lightGrey,
		marginRight: 0,
	},
	search_input: {
		backgroundColor: 'rgba(255,255,255,0.2)',
		color: colors.white,
		borderRadius: 5,
		width: 120,
		fontSize: 14,
		paddingLeft: 8,
		paddingRight: 8,
		paddingTop: 8,
		paddingBottom: 8,
		// height: '100%',
	},
	search_modal: {
		backgroundColor: colors.darkBlue,
		height: '90%',
		marginTop: '5%',
		width: '90%',
		marginLeft: '5%',
		borderRadius: 10,
		elevation: 5,
	},
	search_genre_bigCategory: {
		display: 'flex',
		flexDirection: 'row',
		flexWrap: 'wrap',
		justifyContent: 'center',
		flex: 0.5,
	},
	search_genre_row: {
		display: 'flex',
		flexDirection: 'row',
	},
	date_box: {
		flexDirection: 'row',
		alignItems: 'flex-end',
	},
	eventMonth: {
		textTransform: 'uppercase',
		fontSize: 10 * coef,
		color: colors.white,
		// alignSelf: 'bottom',
		paddingBottom: 3 * coef,
		paddingLeft: 2 * coef,
		fontFamily: 'Lato_400Regular',
		// wordWrap: 'breakWord',
		// width: '1px',
		// textAlign: 'center',
		// letterSpacing: 0,
	},
	support_text: {
		position: 'absolute',
		bottom: 10 * coef,
		textAlign: 'center',
		left: 20 * coef,
		// transform: 'translateX(-50%)',
		color: colors.black2,
		backgroundColor: '#ffd43b',
		fontFamily: 'Lato_400Regular',
		textTransform: 'uppercase',

		fontSize: 10 * coef,
		paddingLeft: 30 * coef,
		paddingRight: 30 * coef,
		paddingTop: 2 * coef,
		paddingBottom: 2 * coef,
		borderRadius: 3 * coef,
		// borderTopLeftRadius: 0,
		// borderTopRightRadius: 0,
		// borderBottomLeftRadius: 8,
		// borderBottomRightRadius: 8,
		transform: [{ translateX: -53 * coef }, { rotate: '45deg' }],
	},
	free_text: {
		position: 'absolute',
		top: 45 * coef,
		textAlign: 'center',
		left: 23 * coef,
		// transform: 'translateX(-50%)',
		color: colors.black2,
		backgroundColor: '#51cf66',
		fontFamily: 'Lato_400Regular',
		textTransform: 'uppercase',

		fontSize: 10 * coef,
		paddingLeft: 30 * coef,
		paddingRight: 30 * coef,
		paddingTop: 2 * coef,
		paddingBottom: 2 * coef,
		borderRadius: 3 * coef,
		// borderTopLeftRadius: 0,
		// borderTopRightRadius: 0,
		// borderBottomLeftRadius: 8,
		// borderBottomRightRadius: 8,
		transform: [{ translateX: -53 * coef }, { rotate: '45deg' }],
	},

	newImage: {
		height: 280,
	},
});
